import { ROUTES } from "@/constants/routes";
import { MissionCategory } from "@prisma/client";

export function getMissionActionRoute(
  category: MissionCategory,
  missionId: string,
  actionId: string,
): string {
  if (category === MissionCategory.QUIZ) {
    return ROUTES.QUIZ({ missionId, quizId: actionId });
  }
  return ROUTES.ACTION({ missionId, actionId });
}
